module.exports = __webpack_public_path__ + "img/Cover_FS_18.14db6ecc.jpg";